import { Component, CUSTOM_ELEMENTS_SCHEMA, effect, inject, input, InputSignal, output, signal } from '@angular/core';
import { DateFieldComponent, TimeFieldsComponent, MovilityFieldComponent, LocationFieldComponent, TripTypesFieldComponent, InterestsFieldComponent, TransportMeansFieldComponent, MaxDistanceFieldComponent } from "../../shared/components";
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { FormGroup } from '@angular/forms';
import { MatTooltip } from '@angular/material/tooltip';
import { RegisterUserFormService, RegisterUserService } from '../../services';
import { openCiSnackbar, closeAllCiSnackbar } from '@iurban-malaga/cicerone-ui';
import { RegisterUserFormStatus, statusFormMap } from '../../interfaces';


@Component({
  selector: 'app-register-user-form-desktop',
  standalone: true,
  imports: [
    TranslateModule,
    DateFieldComponent,
    TimeFieldsComponent,
    MovilityFieldComponent,
    LocationFieldComponent,
    TripTypesFieldComponent,
    InterestsFieldComponent,
    TransportMeansFieldComponent,
    MaxDistanceFieldComponent,
    MatTooltip
],
  templateUrl: './register-user-form-desktop.component.html',
  styleUrls: ['./register-user-form-desktop.component.scss'],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class RegisterUserFormDesktopComponent  {
  public form: InputSignal<FormGroup> = input.required<FormGroup>();
  
  public submitFormEmitter = output<void>();
  
  private _translateService = inject(TranslateService);
  private _registerUserService = inject(RegisterUserService);
  private _registerUserFormService = inject(RegisterUserFormService);
  
  protected cityLocation = this._registerUserService.cityLocation;
  
  private _formStatus = signal<RegisterUserFormStatus>(statusFormMap.INVALID);
  
  trackFormChanges = effect(() => {
    const form = this.form();
    
    // Subscription to statusChanges of the FormGroup
    form.statusChanges.subscribe((status: RegisterUserFormStatus) => {
      this._formStatus.set(status);
    });
    
    // init with current status
    this._formStatus.set(form.status as RegisterUserFormStatus);
  });
  
  closeSnackbarOnValidForm = effect(() => {
    const status = this._formStatus();

    if (status === statusFormMap.VALID) {
      closeAllCiSnackbar();
    }
  }, { allowSignalWrites: true });

  public tooltipText(): string {
    return this.form().valid
      ? this._translateService.instant('Comenzar a planificar')
      : this._translateService.instant('Revisa los campos obligatorios antes de enviar');
  }
  
  public handleSubmit(): void {
    if (this.form().invalid) {
      this._registerUserFormService.setMarkAllFormFieldsAsTouched(true);
      this._openErrorFormSnackbar();
    } else {
      closeAllCiSnackbar();
    }
    
    this.submitFormEmitter.emit();
  }
  
  private _openErrorFormSnackbar() {
    openCiSnackbar({
      content: this._translateService.instant('Revisa los campos del formulario que son obligatorios'),
      status: 'error',
      'icon-name': 'error',
      'horizontal-position': 'end',
      'vertical-position': 'bottom',
    })
  } 
}
